import "./Sidebar.css";
import {
  FaPowerOff,
  FaTh,
  FaGraduationCap,
  FaMoneyBill,
  FaChevronRight,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";

import appLogo from "../../assets/logo/blue-logo.png";

const Sidebar = ({ sidebarOpen, toggleSidebar }) => {
  const reverseSidebar = () => {
    toggleSidebar();
  };

  return (
    <div className={sidebarOpen ? "sidebar_responsive" : ""} id="sidebar">
      <div className="sidebar_title">
        <div className="flex flex-center direction-column align-center sidebar-image-container">
          <img className="sidebar-header-image" src={appLogo} alt="logo" />
          <div>
            <strong>Super Admin</strong>
          </div>
        </div>
      </div>

      <div className="sidebar_menu">
        {/* sidebar link */}
        <div className="separator">Home</div>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/dashboard"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaTh className="sidebar_link_icon" />
              <span className="sidebar_link_text">Dashboard</span>
            </div>
          )}
        </NavLink>

        <div className="separator">Users</div>
        {/* sidebar link */}
        <NavLink
          onClick={() => reverseSidebar()}
          to="/schools"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaGraduationCap className="sidebar_link_icon" />
              <div className="sidebar_link_text">Schools</div>
            </div>
          )}
        </NavLink>
        <div className="separator">Finance</div>
        {/* sidebar link */}
        <NavLink
          onClick={() => reverseSidebar()}
          to="/subscription/home"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaMoneyBill className="sidebar_link_icon" />
              <div className="sidebar_link_text">
                <span>Subscriptions</span> <FaChevronRight size={10} />{" "}
              </div>
            </div>
          )}
        </NavLink>
        {/* sidebar link */}
        <NavLink
          onClick={() => reverseSidebar()}
          to="/payment"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaMoneyBill className="sidebar_link_icon" />
              <div className="sidebar_link_text">Payment</div>
            </div>
          )}
        </NavLink>

        {/* sidebar link */}
        <div className="sidebar_logout mb-20">
          <FaPowerOff className="sidebar_logout_icon" />
          <NavLink to="/logout" className="sidebar_logout_text">
            Logout
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
